import { Controller } from "@hotwired/stimulus"
import $ from "jquery"


export default class extends Controller {
  static values = {
    autoopen: Boolean,
    removeOnClose: Boolean
  }

  get $el() { return $(this.element) }

  connect() {
    if (this.autoopenValue) {
      this.open()
    }

    if (this.removeOnCloseValue) {
      this.$el.one("hidden.bs.modal", () => {
        this.element.remove()
      })
    }
  }

  open() {
    this.$el.modal("show")
  }

  close() {
    this.$el.modal("hide")
  }
}
